/**
 * @generated SignedSource<<eca0e05a9c68d84ae99033b5288dc975>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductStatus = "PUBLISHED" | "UN_PUBLISHED";
export type SetStatusProductInput = {
  productID: string;
  status: ProductStatus;
};
export type productListProductSetStatusMutation$variables = {
  input: SetStatusProductInput;
};
export type productListProductSetStatusMutation$data = {
  readonly setStatusProduct: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly model: {
      readonly id: string;
      readonly statusID: number;
    } | null;
  };
};
export type productListProductSetStatusMutation = {
  response: productListProductSetStatusMutation$data;
  variables: productListProductSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Model",
  "kind": "LinkedField",
  "name": "model",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productListProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productListProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "600f7ed37973ea12acc99e4a943388a1",
    "id": null,
    "metadata": {},
    "name": "productListProductSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation productListProductSetStatusMutation(\n  $input: SetStatusProductInput!\n) {\n  setStatusProduct(input: $input) {\n    model {\n      id\n      statusID\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9b20e7b63522034e72cf6d62fd16ee0";

export default node;
